// extracted by mini-css-extract-plugin
export default {"component":"TrustpilotModal__component-VuJy","starRating":"TrustpilotModal__starRating-SWNp"};